/**
 * Fixed Pricing Catalog for VisaProofs Frontend
 * Matches backend authoritative pricing catalog for display and estimation.
 */

export const FIXED_PRICING_CATALOG = {
  USD: { code: 'USD', name: 'US Dollar', symbol: '$', decimals: 2, onewaytrip: 9.00, roundtrip: 14.00 },
  GBP: { code: 'GBP', name: 'British Pound', symbol: '£', decimals: 2, onewaytrip: 7.50, roundtrip: 11.50 },
  EUR: { code: 'EUR', name: 'Euro', symbol: '€', decimals: 2, onewaytrip: 8.50, roundtrip: 13.00 },
  CAD: { code: 'CAD', name: 'Canadian Dollar', symbol: 'CA$', decimals: 2, onewaytrip: 12.50, roundtrip: 19.00 },
  AUD: { code: 'AUD', name: 'Australian Dollar', symbol: 'A$', decimals: 2, onewaytrip: 14.00, roundtrip: 21.50 },
  JPY: { code: 'JPY', name: 'Japanese Yen', symbol: '¥', decimals: 0, onewaytrip: 1350, roundtrip: 2100 },
  CHF: { code: 'CHF', name: 'Swiss Franc', symbol: 'CHF', decimals: 2, onewaytrip: 8.00, roundtrip: 12.50 },
  HKD: { code: 'HKD', name: 'Hong Kong Dollar', symbol: 'HK$', decimals: 2, onewaytrip: 70.00, roundtrip: 110.00 },
  SGD: { code: 'SGD', name: 'Singapore Dollar', symbol: 'S$', decimals: 2, onewaytrip: 12.00, roundtrip: 18.50 },
  NZD: { code: 'NZD', name: 'New Zealand Dollar', symbol: 'NZ$', decimals: 2, onewaytrip: 15.00, roundtrip: 23.00 },
  SEK: { code: 'SEK', name: 'Swedish Krona', symbol: 'kr', decimals: 2, onewaytrip: 95.00, roundtrip: 145.00 },
  NOK: { code: 'NOK', name: 'Norwegian Krone', symbol: 'kr', decimals: 2, onewaytrip: 95.00, roundtrip: 145.00 },
  DKK: { code: 'DKK', name: 'Danish Krone', symbol: 'kr', decimals: 2, onewaytrip: 65.00, roundtrip: 100.00 },
  PLN: { code: 'PLN', name: 'Polish Zloty', symbol: 'zł', decimals: 2, onewaytrip: 36.00, roundtrip: 55.00 },
  CZK: { code: 'CZK', name: 'Czech Koruna', symbol: 'Kč', decimals: 2, onewaytrip: 210.00, roundtrip: 320.00 },
  HUF: { code: 'HUF', name: 'Hungarian Forint', symbol: 'Ft', decimals: 0, onewaytrip: 3300, roundtrip: 5100 },
  ILS: { code: 'ILS', name: 'Israeli New Shekel', symbol: '₪', decimals: 2, onewaytrip: 33.00, roundtrip: 50.00 },
  MXN: { code: 'MXN', name: 'Mexican Peso', symbol: 'MX$', decimals: 2, onewaytrip: 160.00, roundtrip: 250.00 },
  PHP: { code: 'PHP', name: 'Philippine Peso', symbol: '₱', decimals: 2, onewaytrip: 500.00, roundtrip: 780.00 },
  THB: { code: 'THB', name: 'Thai Baht', symbol: '฿', decimals: 2, onewaytrip: 320.00, roundtrip: 500.00 },
  TWD: { code: 'TWD', name: 'New Taiwan Dollar', symbol: 'NT$', decimals: 2, onewaytrip: 280.00, roundtrip: 440.00 },
};

/**
 * Calculates display price from fixed catalog based on currency and tripType.
 *
 * @param {string} currencyCode
 * @param {string} tripType - 'onewaytrip' | 'roundtrip' | 'one-way' | 'round-trip'
 * @returns {{ amount: number, currency: string, symbol: string, decimals: number }}
 */
export function calculateOrderPrice(currencyCode, tripType) {
  const code = (currencyCode || 'USD').trim().toUpperCase();
  const pricing = FIXED_PRICING_CATALOG[code] || FIXED_PRICING_CATALOG.USD;
  
  const isRoundTrip = String(tripType).toLowerCase().includes('round');
  const rawPrice = isRoundTrip ? pricing.roundtrip : pricing.onewaytrip;
  const amount = Number(rawPrice.toFixed(pricing.decimals));

  return {
    amount,
    currency: pricing.code,
    symbol: pricing.symbol,
    decimals: pricing.decimals,
  };
}
